var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: _vm.$t("referenceData.importTitle"),
        width: "1200px",
        "destroy-on-close": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose
      }
    },
    [
      _c(
        "el-steps",
        {
          staticClass: "mb-20",
          attrs: {
            active: _vm.currentStep,
            "finish-status": "success",
            "align-center": ""
          }
        },
        [
          _c("el-step", {
            attrs: { title: _vm.$t("referenceData.importStepUpload") }
          }),
          _vm._v(" "),
          _c("el-step", {
            attrs: { title: _vm.$t("referenceData.importStepChooseKey") }
          }),
          _vm._v(" "),
          _c("el-step", {
            attrs: { title: _vm.$t("referenceData.importStepValidate") }
          }),
          _vm._v(" "),
          _c("el-step", {
            attrs: { title: _vm.$t("referenceData.importStepConfirm") }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentStep === _vm.STEPS.UPLOAD,
              expression: "currentStep === STEPS.UPLOAD"
            }
          ],
          staticClass: "import-step"
        },
        [
          _c(
            "el-upload",
            {
              ref: "upload",
              staticClass: "import-upload",
              attrs: {
                action: "",
                "auto-upload": false,
                "on-change": _vm.handleFileChange,
                "show-file-list": false,
                disabled: _vm.loading,
                drag: "",
                accept: ".csv"
              }
            },
            [
              _c("i", { staticClass: "el-icon-upload" }),
              _vm._v(" "),
              _c("div", { staticClass: "el-upload__text" }, [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("referenceData.dragOrClick")) +
                    "\n\t\t\t"
                )
              ])
            ]
          ),
          _vm._v(" "),
          _vm.error
            ? _c("el-alert", {
                staticClass: "mt-10",
                attrs: {
                  title: _vm.error,
                  type: "error",
                  "show-icon": "",
                  closable: false
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.currentStep >= _vm.STEPS.CHOOSE_KEY
        ? _c(
            "div",
            { staticClass: "import-step" },
            [
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === _vm.STEPS.CHOOSE_KEY,
                      expression: "currentStep === STEPS.CHOOSE_KEY"
                    }
                  ],
                  staticClass: "mb-15",
                  attrs: { inline: "" }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("referenceData.keyColumnLabel") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "280px" },
                          attrs: {
                            placeholder: _vm.$t("referenceData.selectKeyColumn")
                          },
                          model: {
                            value: _vm.selectedKeyColumn,
                            callback: function($$v) {
                              _vm.selectedKeyColumn = $$v
                            },
                            expression: "selectedKeyColumn"
                          }
                        },
                        _vm._l(_vm.previewColumns, function(col) {
                          return _c("el-option", {
                            key: col,
                            attrs: { label: col, value: col }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === _vm.STEPS.VALIDATE,
                      expression: "currentStep === STEPS.VALIDATE"
                    }
                  ],
                  staticClass: "mb-15"
                },
                [
                  _vm.loading
                    ? _c(
                        "el-row",
                        {
                          staticClass: "p-20",
                          attrs: { type: "flex", justify: "center" }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-loading",
                            staticStyle: { "font-size": "24px" }
                          })
                        ]
                      )
                    : _vm.error
                    ? _c("el-alert", {
                        attrs: {
                          title: _vm.error,
                          type: "error",
                          "show-icon": "",
                          closable: false
                        }
                      })
                    : _c("el-alert", {
                        attrs: {
                          title: _vm.$t("referenceData.validationSuccess"),
                          type: "success",
                          "show-icon": "",
                          closable: false
                        }
                      })
                ],
                1
              ),
              _vm._v(" "),
              _vm.currentStep === _vm.STEPS.CONFIRM && _vm.error
                ? _c("el-alert", {
                    staticClass: "mb-15",
                    attrs: {
                      title: _vm.error,
                      type: "error",
                      "show-icon": "",
                      closable: false
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v(_vm._s(_vm.$t("referenceData.preview")))
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.previewRows,
                    border: "",
                    size: "small",
                    "max-height": "300"
                  }
                },
                _vm._l(_vm.previewColumns, function(col) {
                  return _c("el-table-column", {
                    key: col,
                    attrs: {
                      prop: col,
                      label: col,
                      "show-overflow-tooltip": "",
                      "min-width": "120"
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("cancel")))
          ]),
          _vm._v(" "),
          _vm.currentStep > _vm.STEPS.UPLOAD
            ? _c(
                "el-button",
                {
                  attrs: { type: "default", disabled: _vm.loading },
                  on: {
                    click: function($event) {
                      _vm.currentStep--
                    }
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.$t("referenceData.previous")) +
                      "\n\t\t"
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentStep < _vm.STEPS.CONFIRM
            ? _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: !_vm.canProceed,
                    loading: _vm.loading
                  },
                  on: { click: _vm.onNextStep }
                },
                [
                  _vm._v(
                    "\n\t\t\t" + _vm._s(_vm.$t("referenceData.next")) + "\n\t\t"
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentStep === _vm.STEPS.CONFIRM
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handleConfirm }
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.$t("referenceData.confirmImport")) +
                      "\n\t\t"
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }